import * as React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.5 24a.5.5 0 0 1-.5-.5V12H5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5H8V5.355c0-.669.102-1.965.782-3.128C9.648.749 11.124 0 13.171 0H17.5a.5.5 0 0 1 .5.5v4.01a.499.499 0 0 1-.5.5c-.002 0-2.57-.01-2.988-.01l-.047-.001a.47.47 0 0 0-.47.534A.516.516 0 0 1 14 5.6V7h3.768a.501.501 0 0 1 .497.552l-.417 3.999a.498.498 0 0 1-.497.449H14v11.5a.5.5 0 0 1-.5.5h-5zm4.5-1V11.5a.5.5 0 0 1 .5-.5h3.4l.313-3H13.5a.5.5 0 0 1-.5-.5V5.63c-.041-.377.063-.75.293-1.052a1.467 1.467 0 0 1 1.172-.579c.023 0 .047 0 .07.002h.084c.407 0 1.553.005 2.271.007h.109V1H13.17C11.613 1 9 1.566 9 5.355V7.5a.5.5 0 0 1-.5.5H6v3h2.5a.5.5 0 0 1 .5.5V23h4z"
});

var SvgShareFacebook = function SvgShareFacebook() {
  return _ref;
};

export default SvgShareFacebook;